var LocationsGroupsFiltersModule = /** @class */ (function () {
    function LocationsGroupsFiltersModule() {
    }
    return LocationsGroupsFiltersModule;
}());
export { LocationsGroupsFiltersModule };
